export default __webpack_public_path__ + "img/d89e89666a4cad0c507c535e97db0e3a.gif";